import React from 'react'

import { colors } from '@flowwai-frontend/shared/style-guide'

import { IconPropsType } from '../types'

const Rocket1Icon = (props: IconPropsType): React.ReactElement => {
   const { height = 20, width = 20, fill = colors['blue-light-600'] } = props

   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         width={width}
         height={height}
         fill='none'
         viewBox='0 0 20 20'
      >
         <path
            fill={fill}
            d='M11.221 3.643a18.008 18.008 0 012.774 2.274c.878.878 1.64 1.816 2.285 2.79l.174.279c.208.331.311.497.337.67a.833.833 0 01-.059.45c-.069.16-.211.294-.497.561l-1.922 1.798.541 1.622.019.054c.067.2.152.451.155.715.004.229-.04.455-.128.666-.101.244-.273.445-.41.606l-.037.044-1.302 1.538c-.223.264-.426.504-.608.683-.185.182-.443.4-.795.486-.457.113-.94.028-1.33-.234-.302-.203-.47-.495-.581-.73a10.81 10.81 0 01-.338-.85l-.272-.736a4.715 4.715 0 01-3.674-.704l-2.047 2.047a.833.833 0 01-1.179-1.178l2.036-2.035a4.714 4.714 0 01-.758-3.753l-.737-.27c-.324-.12-.62-.23-.85-.339-.234-.111-.526-.28-.729-.58a1.667 1.667 0 01-.235-1.33c.088-.353.305-.611.487-.796.179-.182.419-.385.683-.608L3.762 5.48l.044-.037c.16-.137.362-.309.606-.41.21-.088.437-.132.665-.128.264.003.516.088.715.155l.055.019 1.622.54 1.809-1.934c.276-.295.414-.442.58-.511a.834.834 0 01.461-.052c.177.03.344.143.679.37l.218.146.005.004zM12.146 2.256c-.249-.168-.19-.539.104-.6.789-.161 1.613-.232 2.393-.362.59-.098 1.086-.181 1.49-.212.417-.031.843-.018 1.25.156a2.5 2.5 0 011.312 1.312c.175.407.188.834.156 1.25-.03.405-.113.901-.211 1.49-.132.792-.2 1.635-.369 2.435-.06.289-.427.34-.584.09-.7-1.118-1.584-2.147-2.514-3.076a19.676 19.676 0 00-3.027-2.483z'
         ></path>
      </svg>
   )
}

export { Rocket1Icon }
